import React from 'react';
import { FadeIn } from './FadeIn';
import { CTAButton } from './CTAButton';
export function Hero() {
  return <section className="bg-cream min-h-[90vh] flex items-center pt-12 pb-20 px-6 md:px-12 lg:px-24 overflow-hidden" data-id="element-56">
      <div className="max-w-7xl mx-auto w-full grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-57">
        {/* Mobile Image (shows first on mobile) */}
        <div className="lg:hidden relative w-full max-w-md mx-auto" data-id="element-58">
          <FadeIn direction="down" data-id="element-59">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl" data-id="element-60">
              <img src="https://cdn.magicpatterns.com/uploads/rN1hWQzMW5eEhUbGgRgRJV/mama_mirsando_ipad_y_el_bebe.png" alt="Mamá feliz usando el método SOS Sueño Infantil" className="w-full h-auto object-cover" data-id="element-61" />
            </div>
          </FadeIn>
        </div>

        <div className="flex flex-col justify-center space-y-8 z-10" data-id="element-62">
          <FadeIn delay={0.1} data-id="element-63">
            <p className="text-xs md:text-sm text-brown/40 tracking-widest uppercase mb-4" data-id="element-64">
              Método digital paso a paso · Sin dejarlo llorar · Acceso inmediato
            </p>
            <span className="text-periwinkle font-semibold tracking-wider uppercase text-sm md:text-base mb-2 block" data-id="element-65">
              SOS Sueño Infantil
            </span>
            <h1 className="text-5xl md:text-6xl lg:text-7xl leading-tight text-brown mb-4" data-id="element-66">
              De 3 despertares a 0: recupera tu descanso en 72 horas sin dejar a
              tu bebé llorando solo
            </h1>
          </FadeIn>

          <FadeIn delay={0.2} data-id="element-67">
            <p className="text-xl md:text-2xl text-brown/80 font-medium leading-relaxed" data-id="element-68">
              Descubre El Método del Ancla Invisible, una guía práctica y
              amorosa para ayudar a tu bebé a dormir mejor.
            </p>
          </FadeIn>

          <FadeIn delay={0.3} data-id="element-69">
            <CTAButton className="mt-4" data-id="element-70">Quiero recuperar mi descanso</CTAButton>
          </FadeIn>
        </div>

        {/* Desktop Image */}
        <div className="hidden lg:block relative w-full h-full min-h-[500px]" data-id="element-71">
          <FadeIn direction="left" className="h-full flex items-center justify-center relative" data-id="element-72">
            <div className="relative rounded-3xl overflow-hidden shadow-2xl transform rotate-2 hover:rotate-0 transition-transform duration-500" data-id="element-73">
              <img src="https://cdn.magicpatterns.com/uploads/rN1hWQzMW5eEhUbGgRgRJV/mama_mirsando_ipad_y_el_bebe.png" alt="Mamá feliz usando el método SOS Sueño Infantil" className="w-full h-auto max-w-lg object-cover" data-id="element-74" />
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}